import { render, staticRenderFns } from "./OutputCustomize.vue?vue&type=template&id=bc27e8bc&scoped=true"
import script from "./OutputCustomize.vue?vue&type=script&lang=js"
export * from "./OutputCustomize.vue?vue&type=script&lang=js"
import style0 from "./OutputCustomize.vue?vue&type=style&index=0&id=bc27e8bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc27e8bc",
  null
  
)

export default component.exports